import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import "../css/landingPage.css";
import cst from "../images/partnerLogos/cst.png";
import kenli from "../images/partnerLogos/kenli.png";
import kmc from "../images/partnerLogos/kmc.png";
import maxxis from "../images/partnerLogos/maxxis.png";
import wtb from "../images/partnerLogos/wtb.png";
import schwalbe from "../images/partnerLogos/schwalbe.png";
import neco from "../images/partnerLogos/neco.png";
import ralson from "../images/partnerLogos/ralson.png";
import prowheel from "../images/partnerLogos/prowheel.png";
import sunrace from "../images/partnerLogos/sunrace.png";
import shimano from "../images/partnerLogos/shimano.png";
import sram from "../images/partnerLogos/sram.png";
import rockshox from "../images/partnerLogos/rockshox.png";
import microshift from "../images/partnerLogos/microshift.png";
import axios from "axios";
import PhoneInput from "react-phone-number-input";
import Meta from "../components/Meta";
import Modal from "../components/Modal";
import ModalMobile from "../components/ModalMobile";
import ReactPlayer from "react-player";
import CustomBike from "../components/CustomBike";
import "../css/navbar.css";
import logo from "../images/brandLogos/Dynem red white.png";
import { Icon } from "@iconify/react";
import ReCAPTCHA from "react-google-recaptcha";
import "../css/landingPage2.css";
import IntlTelInput from "intl-tel-input/reactWithUtils";
import "intl-tel-input/styles";

const LandingPage2Es = () => {
  const [capVal, setCapVal] = useState("");

  const featuresData = [
    {
      key: "precisionControllers",
      heading: "Controladores de Precisión",
      description:
        "Los controladores de bicicletas eléctricas utilizan sensores y algoritmos inteligentes para distribuir la potencia con fluidez, mejorando el rendimiento y haciendo que los paseos sean más intuitivos. Construye de forma más inteligente con los componentes DYNEM.",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/Controlerrrr.png",
    },
    {
      key: "highPerformanceChargers",
      heading: "Cargadores de Alto Rendimiento",
      description:
        "Nuestros cargadores están disponibles en opciones personalizables, diseñados para brindar compatibilidad global, fácil portabilidad y flexibilidad en sus necesidades de energía. Impulse su marca con DYNEM.",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/Chargerrrr.png",
    },
    {
      key: "multifunctionalDisplays",
      heading: "Pantalla Multifuncional",
      description:
        "Las pantallas LCD multifuncionales muestran estadísticas en tiempo real, como la velocidad y el nivel de batería, lo que ayuda a los ciclistas a mantener el control y cambiar de modo fácilmente. Mejora tu tecnología de conducción con DYNEM.",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/Displayyyyy.png",
    },
    {
      key: "longLastingBatteries",
      heading: "Baterías de larga duración",
      description:
        "Nuestras baterías de larga duración están diseñadas para ofrecer un rendimiento constante, una mayor vida útil y una entrega de potencia óptima, garantizando la fiabilidad de cada salida. Energiza tus bicicletas eléctricas con DYNEM.",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/Baterryyyyy.png",
    },
    {
      key: "efficientMotors",
      heading: "Motores Eficientes",
      description:
        "Nuestros motores eficientes ofrecen un rendimiento fiable y preciso en todas las aplicaciones: diseñados para la potencia y para un propósito. Impulse su innovación con DYNEM.",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/motorrrr.png",
    },
  ];
  const [open, openNav] = useState(false);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "auto",
    });
  }, []);

  const closeNavforDeadLink = () => {
    openNav(false);
  };

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [country, setCountry] = useState("");
  const [enquiry, setEnquiry] = useState("");
  const [sales, setSales] = useState("");
  const [productPortfolio, setProductPortfolio] = useState("");

  const navigate = useNavigate();
  const submit = async (e) => {
    e.preventDefault();
    if (!phoneNumber.trim()) {
      alert("Enter Contact Number");
      return;
    }
    const response = await fetch("/api/verify-captcha", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ capVal }),
    });

    const dataCaptcha = await response.json();
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const reqBody = {
      name,
      email,
      phoneNumber,
      companyName,
      enquiry,
      country,
      sales,
      productPortfolio,
    };
    if (dataCaptcha) {
      const { data } = await axios.post(
        "/api/form/request-a-quote",
        reqBody,
        config
      );
      if (data) {
        navigate("/details-submitted");
      }
    } else {
      alert("CAPTCHA Verification Failed!");
    }
  };
  return (
    <>
      <div
        className="position-fixed w-100 d-lg-none"
        style={{ bottom: "1.5%", zIndex: 2 }}
      >
        <div className="d-flex justify-content-center">
          <Link
            to={"/landing-page/form"}
            style={{ width: "85%" }}
            className="btn btn-danger py-2 rounded-5"
          >
            Get in Touch
          </Link>
        </div>
      </div>

      <div id="LandingPage2">
        {/* hero-section */}
        <div className="position-relative">
          <div
            className="position-absolute w-100"
            style={{ top: "2%", zIndex: "1" }}
          >
            <div className="d-lg-block d-none">
              <div className="d-flex justify-content-between align-items-center px-lg-5 mb-5">
                <Link to={"/"}>
                  <img src={logo} alt="dynem-logo" className="logo"></img>
                </Link>
                <Link
                  to={"/"}
                  className="btn btn-danger fw-bold px-4 py-2 rounded-5"
                  style={{ backgroundColor: "#ff0000" }}
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                >
                  Get in Touch
                </Link>
              </div>
              <div>
                <h3 className="poppins-bold mb-3 text-center text-uppercase text-light">
                  El mayor fabricante y exportador de bicicletas eléctricas del
                  Sudeste Asiático
                </h3>
                <h5 className="text-light text-center poppins-medium">
                  Construyendo el futuro de la movilidad
                </h5>
              </div>
            </div>

            <div className="d-lg-none">
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ gap: "2em", flexDirection: "column" }}
              >
                <Link to={"/"}>
                  <img src={logo} alt="dynem-logo" className="logo"></img>
                </Link>
                <div>
                  <h5 className="poppins-bold mb-3 text-center text-uppercase text-light">
                    El mayor fabricante y exportador de bicicletas eléctricas
                    del Sudeste Asiático
                  </h5>
                  <p className="text-light text-center poppins-medium">
                    Construyendo el futuro de la movilidad
                  </p>
                </div>
              </div>
            </div>
          </div>
          <video
            className="w-100"
            autoPlay
            loop
            muted
            playsInline
            style={{ height: "100vh", width: "100vw", objectFit: "cover" }}
          >
            <source
              media="(max-width:650px)"
              src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/Landing+page+video+phone+view+.mp4"
              type="video/mp4"
            />
            <source
              media="(min-width:651px)"
              src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/Landing+Page+video+desktop+view+.mp4"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
          <div
            className="position-absolute d-lg-block d-none w-100"
            style={{ bottom: "8%" }}
          >
            <div
              className="w-100 d-flex justify-content-center container px-5"
              style={{ gap: "12em" }}
            >
              <div className="text-center">
                <h4 className="poppins-medium text-light mb-3">
                  240,000 pies²
                </h4>
                <h5 className="poppins-bold text-light mb-3">de Gigafábrica</h5>
              </div>
              <div className="text-center">
                <h4 className="poppins-medium text-light mb-3">500,000</h4>
                <h5 className="poppins-bold text-light mb-3">
                  E-Bikes de capacidad de producción anual
                </h5>
              </div>
              <div className="text-center">
                <h4 className="poppins-medium text-light mb-3">18+</h4>
                <h5 className="poppins-bold text-light mb-3">países</h5>
              </div>
            </div>
          </div>
          <div
            className="position-absolute d-lg-none text-light"
            style={{ bottom: "13%" }}
          >
            <div
              className="w-100 d-flex justify-content-center container px-3"
              style={{ gap: "0.9em" }}
            >
              <div className="text-center">
                <p
                  className="poppins-medium text-light mb-1"
                  style={{ fontSize: "0.8em" }}
                >
                  240,000 pies²
                </p>
                <p
                  className="poppins-bold text-light mb-1"
                  style={{ fontSize: "0.6em" }}
                >
                  de Gigafábrica
                </p>
              </div>
              <div className="text-center">
                <p
                  className="poppins-medium text-light mb-1"
                  style={{ fontSize: "0.8em" }}
                >
                  500,000
                </p>
                <p
                  className="poppins-bold text-light mb-1 w-75 mx-auto"
                  style={{ fontSize: "0.6em" }}
                >
                  E-Bikes de capacidad de producción anual
                </p>
              </div>
              <div className="text-center">
                <p
                  className="poppins-medium text-light mb-1"
                  style={{ fontSize: "0.8em" }}
                >
                  18+
                </p>
                <p
                  className="poppins-bold text-light mb-1"
                  style={{ fontSize: "0.6em" }}
                >
                  países
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* form */}
        <div className="d-none d-lg-block my-5 py-lg-5 container">
          <h2 className="poppins-bold mb-4 text-uppercase text-center">
            Construyamos tu próximo gran viaje
          </h2>
          <div className="d-flex justify-content-center mb-4">
            <h5 className="text-center mb-0 col-md-8 text-muted">
              Conéctese con nuestro equipo de desarrollo comercial para explorar
              cómo DYNEM puede impulsar su visión de ciclo eléctrico.
            </h5>
          </div>
          <div className="row p-0">
            <div className="col-6 p-3">
              <h3 className="poppins-medium mb-4">Por qué elegir DYNEM?</h3>
              <div>
                <img
                  src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/Group+49.jpg"
                  className="img-fluid"
                ></img>
              </div>
            </div>
            <div className="col-6 p-3">
              <form className="" onSubmit={submit}>
                <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                  <div className="w-100">
                    <label
                      for="exampleInputEmail1"
                      className="form-label"
                      style={{ fontSize: "0.8em" }}
                    >
                      Nombre*
                    </label>
                    <input
                      style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                      type="text"
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                      }}
                      required
                      class="form-control text-dark"
                      aria-describedby="emailHelp"
                    />
                  </div>
                </div>
                <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                  <div class="w-50">
                    <label
                      for="exampleInputPassword1"
                      class="form-label"
                      style={{ fontSize: "0.8em" }}
                    >
                      Teléfono*
                    </label>
                    <IntlTelInput
                      onChangeNumber={setPhoneNumber}
                      initOptions={{
                        initialCountry: "auto",
                        geoIpLookup: function (success, failure) {
                          fetch("https://ipapi.co/json")
                            .then((res) => res.json())
                            .then((data) => success(data.country_code))
                            .catch(() => failure());
                        },
                        strictMode: true,
                        separateDialCode: true,
                      }}
                    />
                  </div>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label"
                      style={{ fontSize: "0.8em" }}
                    >
                      Correo electrónico*
                    </label>
                    <input
                      style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                      type="email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                      required
                      class="form-control rounded-0"
                      aria-describedby="emailHelp"
                    />
                  </div>
                </div>

                <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1 text-light"
                      style={{ fontSize: "0.8em" }}
                      className="form-label"
                    >
                      Compañía*
                    </label>
                    <input
                      type="text"
                      value={companyName}
                      style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                      required
                      onChange={(e) => {
                        setCompanyName(e.target.value);
                      }}
                      class="form-control"
                      aria-describedby="emailHelp"
                    />
                  </div>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label"
                      style={{ fontSize: "0.8em" }}
                    >
                      Product Portfolio*
                    </label>
                    <select
                      onChange={(e) => setProductPortfolio(e.target.value)}
                      style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                      class="form-select"
                      required
                      defaultValue=""
                      aria-label="Default select example"
                    >
                      <option value="" selected disabled></option>
                      <option value="E-Bikes">E-Bikes</option>
                      <option value="E-Scooters">E-Scooters</option>
                      <option value="Hyper-Bikes">Hyper-Bikes</option>
                      <option value="Moped">Moped</option>
                    </select>
                  </div>
                </div>

                <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label"
                      style={{ fontSize: "0.8em" }}
                    >
                      Operational Countries*
                    </label>
                    <input
                      style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                      type="text"
                      value={country}
                      onChange={(e) => {
                        setCountry(e.target.value);
                      }}
                      class="form-control"
                      aria-describedby="emailHelp"
                    />
                  </div>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label"
                      style={{ fontSize: "0.8em" }}
                    >
                      Annual E-Bike Sales (units)
                    </label>
                    <select
                      style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                      onChange={(e) => setSales(e.target.value)}
                      class="form-select"
                      required
                      defaultValue=""
                      aria-label="Default select example"
                    >
                      <option value="" selected disabled></option>
                      <option value="less than 1000 units">
                        less than 1000 units
                      </option>
                      <option value="1000-5000 units">1000-5000 units</option>
                      <option value="5000-50,000 units">
                        5000-50,000 units
                      </option>
                      <option value="50,000+ units">50,000+ units</option>
                    </select>
                  </div>
                </div>
                <div className="mb-3">
                  <label
                    for="exampleInputEmail1"
                    className="form-label"
                    style={{ fontSize: "0.8em" }}
                  >
                    Mensaje*
                  </label>
                  <textarea
                    style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                    class="form-control rounded-0"
                    required
                    id="exampleFormControlTextarea1"
                    rows="3"
                    value={enquiry}
                    onChange={(e) => {
                      setEnquiry(e.target.value);
                    }}
                  ></textarea>
                </div>
                <div className="mb-3 d-flex justify-content-center">
                  <ReCAPTCHA
                    sitekey="6LftKugqAAAAAP-72NIok7YyszCs5TTba5QBtgBS"
                    onChange={(val) => setCapVal(val)}
                  ></ReCAPTCHA>
                </div>
                <button
                  disabled={!capVal}
                  type="submit"
                  style={{ backgroundColor: "#ff0000" }}
                  class="btn btn-danger w-100 poppins-medium rounded-5 py-2"
                >
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
        {/* ebikes */}
        <div className="container mt-5 py-lg-5 ebike-section-landing-page2">
          <h2 className="poppins-bold mb-4 text-uppercase text-center">
            Del concepto al viaje: su socio OEM para cada etapa
          </h2>
          <div className="d-flex justify-content-center">
            <h5 className="text-center mb-0 col-md-8 text-muted">
              Ya sea que esté lanzando un vehículo urbano o un potente
              todoterreno, DYNEM tiene la tecnología, el diseño y la potencia
              para hacerlo realidad.
            </h5>
          </div>

          <div className="pt-lg-5 pt-4 px-2">
            <Splide
              className="mb-2 mb-lg-0 p-0 align-items-center text-center"
              options={{
                arrows: true,
                start: 0,
                drag: false,
                type: "loop",
                pagination: true,
                autoplay: true,
                gap: "2em",
                padding: "1em",
                pauseOnHover: true,
                resetProgress: false,
                perPage: 1,
                perMove: 1,
                speed: 1000,
                interval: 4000,
                breakpoints: {
                  700: {
                    drag: true,
                    autoplay: false,
                    pagination: "false",
                    perPage: 1,
                    perMove: 1,
                    gap: "2em",
                    padding: "0em",
                    arrows: false,
                    pauseOnHover: false,
                    resetProgress: false,
                  },
                },
              }}
              muted={true}
            >
              <SplideSlide className="h-100 p-2">
                <div className="p-4 pt-0 p-lg-0 d-flex align-items-center ecycle-range-card">
                  <div className="col col-md-6">
                    <img
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/Mountain+bike.png"
                      alt=""
                      className="w-75"
                    />
                  </div>
                  <div className="text-start col col-md-6 p-lg-3">
                    <h4 className="poppins-medium">
                      Bicicletas eléctricas de montaña
                    </h4>
                    <p className="ecycle-range-car-content text-muted">
                      No solo fabricamos bicicletas eléctricas de montaña, sino
                      que diseñamos máquinas listas para la aventura. Diseñadas
                      para terrenos difíciles, nuestra gama todoterreno ofrece
                      potencia, control y rendimiento inigualables. Enfréntate a
                      la naturaleza con DYNEM.
                    </p>
                  </div>
                </div>
              </SplideSlide>
              <SplideSlide className="h-100 p-2">
                <div className="p-4 pt-0 p-lg-0 d-flex align-items-center ecycle-range-card">
                  <div className="col col-md-6">
                    <img
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/Foldable+Fat+tyre.png"
                      alt=""
                      className="w-75"
                    />
                  </div>
                  <div className="text-start col col-md-6 p-lg-3">
                    <h4 className="poppins-medium">
                      Bicicletas eléctricas plegables de neumáticos anchos
                    </h4>
                    <p className="ecycle-range-car-content text-muted">
                      Compactas cuando las necesitas. Robustas cuando las
                      necesitas. Nuestras bicicletas eléctricas plegables de
                      neumáticos anchos están diseñadas para la vida en
                      movimiento: perfectas para paseos urbanos, viajes y
                      escapadas de fin de semana. Encuentra tu libertad plegable
                      con DYNEM.
                    </p>
                  </div>
                </div>
              </SplideSlide>
              <SplideSlide className="h-100 p-2">
                <div className="p-4 pt-0 p-lg-0 d-flex align-items-center ecycle-range-card">
                  <div className="col col-md-6">
                    <img
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/City+Bike.png"
                      alt=""
                      className="w-75"
                    />
                  </div>
                  <div className="text-start col col-md-6 p-lg-3">
                    <h4 className="poppins-medium">
                      Bicicletas eléctricas urbanas
                    </h4>
                    <p className="ecycle-range-car-content text-muted">
                      Deslízate entre el tráfico con facilidad. Nuestras
                      bicicletas eléctricas urbanas combinan tecnología de
                      vanguardia con un diseño moderno para que tus
                      desplazamientos diarios sean cómodos, sencillos y con
                      estilo. Redefine tu estilo urbano con DYNEM.
                    </p>
                  </div>
                </div>
              </SplideSlide>
              <SplideSlide className="h-100 p-2">
                <div className="p-4 pt-0 p-lg-0 d-flex align-items-center ecycle-range-card">
                  <div className="col col-md-6">
                    <img
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/Delivery+bike.png"
                      alt=""
                      className="w-75"
                    />
                  </div>
                  <div className="text-start col col-md-6 p-lg-3">
                    <h4 className="poppins-medium">
                      Bicicletas eléctricas de reparto
                    </h4>
                    <p className="ecycle-range-car-content text-muted">
                      Diseñadas para negocios en movimiento. Estas bicicletas
                      eléctricas están diseñadas para entregas exigentes con
                      cuadros resistentes, gran capacidad de carga y un
                      rendimiento confiable, todo ello sin dejar de ser
                      ecológicas. Mantenga sus operaciones ágiles, inteligentes
                      y sostenibles con DYNEM.
                    </p>
                  </div>
                </div>
              </SplideSlide>
            </Splide>
          </div>
        </div>
        {/* components */}
        <div className="container mt-5 py-lg-5 ebike-section-landing-page2">
          <h2 className="poppins-bold mb-4 text-uppercase text-center">
            Impulsando el corazón de cada bicicleta eléctrica
          </h2>
          <div className="d-flex justify-content-center">
            <h5 className="text-center mb-0 col-md-8 text-muted">
              Ya sea un motor de alto torque o una elegante pantalla digital,
              DYNEM ofrece la precisión, el rendimiento y la confiabilidad para
              potenciar su vehículo con componentes de calidad.
            </h5>
          </div>

          <div className="pt-lg-5 pt-4 px-2">
            <Splide
              className="mb-2 mb-lg-0 p-0 align-items-center text-center"
              options={{
                arrows: true,
                start: 0,
                drag: false,
                type: "loop",
                pagination: true,
                autoplay: true,
                gap: "2em",
                padding: "1em",
                pauseOnHover: true,
                resetProgress: false,
                perPage: 1,
                perMove: 1,
                speed: 1000,
                interval: 4000,
                breakpoints: {
                  700: {
                    drag: true,
                    autoplay: false,
                    pagination: "false",
                    perPage: 1,
                    perMove: 1,
                    gap: "2em",
                    padding: "0em",
                    arrows: false,
                    pauseOnHover: false,
                    resetProgress: false,
                  },
                },
              }}
              muted={true}
            >
              {featuresData.map((feature, index) => (
                <SplideSlide className="h-100 p-2">
                  <div className="p-4 pt-0 p-lg-0 d-flex align-items-center ecycle-range-card">
                    <div className="text-start col col-md-6 p-lg-3 d-lg-block d-none">
                      <h4 className="poppins-medium">{feature.heading}</h4>
                      <p className="ecycle-range-car-content text-muted">
                        {feature.description}
                      </p>
                    </div>
                    <div className="col col-md-6">
                      <img src={feature.image} alt="" className="w-75" />
                    </div>
                    <div className="text-start col col-md-6 p-lg-3 d-lg-none">
                      <h4 className="poppins-medium">{feature.heading}</h4>
                      <p className="component-range-car-content text-muted">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                </SplideSlide>
              ))}
            </Splide>
          </div>
        </div>
        {/* breaker */}
        <div className="mt-5 py-lg-5">
          <picture className="">
            <source
              media="(max-width:650px)"
              srcSet="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/phone+anti+Dumping+banner.png.jpg"
            />
            <source
              media="(min-width:651px)"
              srcSet="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/anti+Dumping+banner.png"
            />
            <img
              src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/anti+Dumping+banner.png"
              alt="assurance"
              className="d-block img-fluid"
            />
          </picture>
        </div>
        {/* trust section */}
        <div className="container mt-5 py-4 py-lg-5 trust-section-landing-page2">
          <h2 className="poppins-bold mb-2 text-uppercase text-center">
            Por qué las marcas globales confían en DYNEM
          </h2>
          <h5 className="text-center mb-0 text-muted">
            Su producto. Nuestra experiencia.
          </h5>
          <div className="mt-5 pt-lg-3">
            <div className="mb-5 pb-lg-3">
              <img
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/end-to-end.jpg"
                className="img-fluid mb-3"
              ></img>
              <h4 className="poppins-medium mb-1 text-uppercase">
                Socio de fabricación integral
              </h4>
              <div className="col-md-6">
                <small>
                  Desde el concepto hasta la entrega final, ofrecemos soluciones
                  completas OEM y de marca blanca adaptadas a las necesidades de
                  su marca.
                </small>
              </div>
            </div>
            <div className="mb-5 pb-lg-3">
              <img
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/stae-of-art.jpg"
                className="img-fluid mb-3"
              ></img>
              <h4 className="poppins-medium mb-1 text-uppercase">
                Fabricación de vanguardia
              </h4>
              <div className="col-md-6">
                <small>
                  Las líneas de producción automatizadas y la ingeniería de
                  precisión garantizan una calidad de construcción constante a
                  gran escala, cumpliendo con los estándares internacionales.
                </small>
              </div>
            </div>
            <div className="mb-5 pb-lg-3">
              <img
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/high-performance.jpg"
                className="img-fluid mb-3"
              ></img>
              <h4 className="poppins-medium mb-1 text-uppercase">
                Tecnología de alto rendimiento
              </h4>
              <div className="col-md-6">
                <small>
                  Integramos motores potentes, baterías de larga duración y
                  sistemas inteligentes de IoT para ofrecer bicicletas
                  eléctricas diseñadas para las necesidades de movilidad
                  modernas.
                </small>
              </div>
            </div>
            <div className="mb-5 pb-lg-3">
              <img
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/e-cycles.jpg"
                className="img-fluid mb-3"
              ></img>
              <h4 className="poppins-medium mb-1 text-uppercase">
                Más de 500.000 ciclos eléctricos al año
              </h4>
              <div className="col-md-6">
                <small>
                  Nuestra infraestructura escalable admite todo tipo de
                  procesos, desde pequeños lotes personalizados hasta la
                  producción global de gran volumen, con rapidez y precisión.
                </small>
              </div>
            </div>
            <div className="mb-5 pb-lg-3">
              <img
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/components.jpg"
                className="img-fluid mb-3"
              ></img>
              <h4 className="poppins-medium mb-1 text-uppercase">
                Más de 4 millones de componentes al año
              </h4>
              <div className="col-md-6">
                <small>
                  Con un abastecimiento de alta capacidad y una integración
                  interna, garantizamos la disponibilidad, la eficiencia y la
                  calidad de todos los componentes.
                </small>
              </div>
            </div>
          </div>
        </div>
        {/* company logos */}
        <div className="logos-landing-page2">
          <h3 className="poppins-bold mb-0 text-center text-uppercase">
            El nombre con el que cuentan las marcas globales
          </h3>
          <div className="container my-lg-5 pb-5 d-none d-lg-block">
            <Splide
              className="flex align-items-center"
              extensions={{ AutoScroll }}
              options={{
                type: "loop",
                autoScroll: {
                  speed: 1,
                  pauseOnHover: false,
                },
                perPage: 6,
                drag: "free",
                arrows: false,
                pagination: false,
                pauseOnHover: false,
                gap: "3em",
                padding: "1em",
                breakpoints: {
                  640: {
                    perPage: 3,
                    gap: "1em",
                  },
                },
              }}
            >
              <SplideSlide className="h-100">
                <div>
                  <img src={shimano} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={kmc} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={maxxis} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={wtb} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={rockshox} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={neco} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={ralson} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={sunrace} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={microshift} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={sram} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={schwalbe} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
            </Splide>
          </div>
          <div className="my-5 d-lg-none">
            <Splide
              className="flex align-items-center"
              extensions={{ AutoScroll }}
              options={{
                type: "loop",
                autoScroll: {
                  speed: 1,
                  pauseOnHover: false,
                },
                perPage: 6,
                drag: "free",
                arrows: false,
                pagination: false,
                pauseOnHover: false,
                gap: "3em",
                padding: "1em",
                breakpoints: {
                  640: {
                    perPage: 3,
                    gap: "1em",
                  },
                },
              }}
            >
              <SplideSlide className="h-100">
                <div>
                  <img src={shimano} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={kmc} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={maxxis} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={wtb} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={rockshox} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={neco} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={ralson} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={sunrace} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={microshift} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={sram} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={schwalbe} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
            </Splide>
          </div>
        </div>
        <div className="my-5 py-lg-5 container">
          <Splide
            className="mb-2 mb-lg-0 p-0 align-items-center text-center"
            options={{
              arrows: true,
              start: 0,
              drag: false,
              type: "loop",
              pagination: true,
              autoplay: true,
              gap: "1em",
              padding: "1em",
              pauseOnHover: false,
              resetProgress: false,
              perPage: 3,
              perMove: 1,
              speed: 1000,
              interval: 4000,
              breakpoints: {
                700: {
                  drag: true,
                  autoplay: false,
                  pagination: "false",
                  perPage: 1,
                  perMove: 1,
                  gap: "2em",
                  padding: "0em",
                  arrows: false,
                  pauseOnHover: false,
                  resetProgress: false,
                },
              },
            }}
          >
            <SplideSlide>
              <div className="p-2">
                <div
                  className="d-flex justify-content-center align-items-center p-3 rounded-3"
                  style={{
                    flexDirection: "column",
                    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <div className="mb-3">
                    <Icon
                      icon="iconoir:profile-circle"
                      width="80"
                      height="80"
                    />
                  </div>
                  <div>
                    <small>
                      “DYNEM no solo suministró componentes; comprendieron la
                      visión de nuestro producto y nos ayudaron a darle vida. Su
                      equipo es como una extensión del nuestro.”
                    </small>
                  </div>
                  <div
                    className="poppins-medium mt-2"
                    style={{ fontSize: "0.85em" }}
                  >
                    <small>
                      – Jefe de Producto, Startup de bicicletas eléctricas
                    </small>
                  </div>
                </div>
              </div>
            </SplideSlide>
            <SplideSlide>
              <div className="p-2">
                <div
                  className="d-flex justify-content-center align-items-center p-3 rounded-3"
                  style={{
                    flexDirection: "column",
                    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <div className="mb-3">
                    <Icon
                      icon="iconoir:profile-circle"
                      width="80"
                      height="80"
                    />
                  </div>
                  <div>
                    <small>
                      “Hemos pasado de 500 a 5000 unidades al mes sin ningún
                      problema. La constancia de DYNEM en la calidad y los
                      plazos ha sido revolucionaria.”
                    </small>
                  </div>
                  <div
                    className="poppins-medium mt-2"
                    style={{ fontSize: "0.85em" }}
                  >
                    <small>
                      – Director de Operaciones, Marca de Movilidad del Sudeste
                      Asiático
                    </small>
                  </div>
                </div>
              </div>
            </SplideSlide>
            <SplideSlide>
              <div className="p-2">
                <div
                  className="d-flex justify-content-center align-items-center p-3 rounded-3"
                  style={{
                    flexDirection: "column",
                    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <div className="mb-3">
                    <Icon
                      icon="iconoir:profile-circle"
                      width="80"
                      height="80"
                    />
                  </div>
                  <div>
                    <small>
                      “Gracias a las exportaciones de DYNEM que cumplen con las
                      normas antidumping, hemos entrado en el mercado de la UE
                      con un ahorro considerable en aranceles: casi un 87 %
                      menos de costes.”
                    </small>
                  </div>
                  <div
                    className="poppins-medium mt-2"
                    style={{ fontSize: "0.85em" }}
                  >
                    <small>
                      – Director de Comercio Internacional, Minorista con sede
                      en EE. UU.
                    </small>
                  </div>
                </div>
              </div>
            </SplideSlide>
            <SplideSlide>
              <div className="p-2">
                <div
                  className="d-flex justify-content-center align-items-center p-3 rounded-3"
                  style={{
                    flexDirection: "column",
                    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <div className="mb-3">
                    <Icon
                      icon="iconoir:profile-circle"
                      width="80"
                      height="80"
                    />
                  </div>
                  <div>
                    <small>
                      “Desde motores de alta eficiencia hasta cuadros robustos,
                      todos los componentes que adquirimos de DYNEM ofrecen
                      rendimiento y durabilidad.”
                    </small>
                  </div>
                  <div
                    className="poppins-medium mt-2"
                    style={{ fontSize: "0.85em" }}
                  >
                    <small>
                      – Director de Tecnología, Marca de Bicicletas Eléctricas
                      de Aventura
                    </small>
                  </div>
                </div>
              </div>
            </SplideSlide>
            <SplideSlide>
              <div className="p-2">
                <div
                  className="d-flex justify-content-center align-items-center p-3 rounded-3"
                  style={{
                    flexDirection: "column",
                    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <div className="mb-3">
                    <Icon
                      icon="iconoir:profile-circle"
                      width="80"
                      height="80"
                    />
                  </div>
                  <div>
                    <small>
                      “La flexibilidad para personalizar nuestra línea de
                      bicicletas eléctricas plegables fue realmente asombrosa.
                      DYNEM nos dio la libertad de crear un producto que refleja
                      nuestra marca.”
                    </small>
                  </div>
                  <div
                    className="poppins-medium mt-2"
                    style={{ fontSize: "0.85em" }}
                  >
                    <small>
                      – Gerente de Producto, Marca de Movilidad Urbana
                    </small>
                  </div>
                </div>
              </div>
            </SplideSlide>
            <SplideSlide>
              <div className="p-2">
                <div
                  className="d-flex justify-content-center align-items-center p-3 rounded-3"
                  style={{
                    flexDirection: "column",
                    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <div className="mb-3">
                    <Icon
                      icon="iconoir:profile-circle"
                      width="80"
                      height="80"
                    />
                  </div>
                  <div>
                    <small>
                      “No solo fabrican, sino que también resuelven problemas.
                      DYNEM nos ayudó a rediseñar piezas clave que realmente
                      mejoraron el rendimiento de nuestras bicicletas.”
                    </small>
                  </div>
                  <div
                    className="poppins-medium mt-2"
                    style={{ fontSize: "0.85em" }}
                  >
                    <small>
                      – Jefe de I+D, Marca Premium de Bicicletas Eléctricas
                    </small>
                  </div>
                </div>
              </div>
            </SplideSlide>
          </Splide>
        </div>
        {/* news */}
        <div className="news">
          <div className="container mt-5 py-4 py-lg-5">
            <h2 className="poppins-bold text-uppercase mb-3 mb-lg-5">
              En las noticias
            </h2>
            <Splide
              className="mb-2 mb-lg-0 p-0 align-items-center"
              options={{
                arrows: false,
                drag: false,
                type: "slide",
                pagination: false,
                autoplay: false,
                perMove: 1,
                gap: "1em",
                padding: "0em",
                pauseOnHover: true,
                resetProgress: false,
                perPage: 4,
                speed: 1000,
                interval: 3000,
                breakpoints: {
                  700: {
                    drag: true,
                    perPage: 1.3,
                    arrows: false,
                    perMove: 1,
                    gap: "1em",
                    padding: "0em",
                    pauseOnHover: false,
                    resetProgress: false,
                    focus: 0,
                    start: 0,
                    speed: 1000,
                    interval: 3000,
                  },
                },
              }}
              muted={true}
            >
              <SplideSlide className="h-100">
                <div className="p-3" style={{ backgroundColor: "white" }}>
                  <div>
                    <img
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/News+1.png"
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                  <img
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/kxan.png"
                    className="img-fluid mt-2"
                  ></img>
                  <p className="my-3 news-heading poppins-medium">
                    DYNEM begins construction of World's Biggest Integrated
                    Electric Cycle Gigafactory.....
                  </p>
                  <small>May 09, 2024</small>
                  <div
                    className="w-100 text-center py-2 mt-2"
                    style={{
                      backgroundColor: "black",
                      minHeight: "max-content",
                    }}
                  >
                    <a
                      className="text-light text-decoration-none"
                      href="https://www.kxan.com/business/press-releases/cision/20240509IO08933/dynem-begins-construction-of-worlds-biggest-integrated-electric-cycle-gigafactory-in-india/"
                    >
                      Read More
                    </a>
                  </div>
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div className="p-3" style={{ backgroundColor: "white" }}>
                  <div>
                    <img
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/News+2.png"
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                  <img
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/ktla.png"
                    className="img-fluid mt-2"
                  ></img>
                  <p className="my-3 news-heading poppins-medium">
                    India’s DYNEM to Establish World’s Largest Integrated E-Bike
                    Gigafactory
                  </p>
                  <small>May 09, 2024</small>
                  <div
                    className="w-100 text-center py-2 mt-2"
                    style={{
                      backgroundColor: "black",
                      minHeight: "max-content",
                    }}
                  >
                    <a
                      className="text-light text-decoration-none"
                      href="https://fox59.com/business/press-releases/cision/20240509IO08933/dynem-begins-construction-of-worlds-biggest-integrated-electric-cycle-gigafactory-in-india/"
                    >
                      Read More
                    </a>
                  </div>
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div className="p-3" style={{ backgroundColor: "white" }}>
                  <div>
                    <img
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/News+3.png"
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                  <img
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/benzinga.png"
                    className="img-fluid mt-2"
                  ></img>
                  <p className="my-3 news-heading poppins-medium">
                    DYNEM Breaks Ground on World’s Largest Integrated Electric
                    Cycle Gigafactory ...
                  </p>
                  <small>May 09, 2024</small>
                  <div
                    className="w-100 text-center py-2 mt-2"
                    style={{
                      backgroundColor: "black",
                      minHeight: "max-content",
                    }}
                  >
                    <a
                      className="text-light text-decoration-none"
                      href="https://www.benzinga.com/pressreleases/24/05/n38730936/dynem-begins-construction-of-worlds-biggest-integrated-electric-cycle-gigafactory-in-india"
                    >
                      Read More
                    </a>
                  </div>
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div className="p-3" style={{ backgroundColor: "white" }}>
                  <div>
                    <img
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/News+4.png"
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                  <img
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/fox8.png"
                    className="img-fluid mt-2"
                  ></img>
                  <p className="my-3 news-heading poppins-medium">
                    DYNEM Strengthens India’s Manufacturing Prowess: World’s
                    Biggest .....
                  </p>
                  <small>May 09, 2024</small>
                  <div
                    className="w-100 text-center py-2 mt-2"
                    style={{
                      backgroundColor: "black",
                      minHeight: "max-content",
                    }}
                  >
                    <a
                      className="text-light text-decoration-none"
                      href="https://www.benzinga.com/pressreleases/24/05/n38730936/dynem-begins-construction-of-worlds-biggest-integrated-electric-cycle-gigafactory-in-india"
                    >
                      Read More
                    </a>
                  </div>
                </div>
              </SplideSlide>
            </Splide>
            <div className="mt-5 pt-lg-4">
              <h2 className="poppins-medium mb-3 mb-lg-4 container">
                Certifications
              </h2>
              <div className="container pb-4">
                <img
                  src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/certifications__png.png"
                  alt="certifications"
                  className="w-100"
                ></img>
              </div>
            </div>
          </div>
        </div>
        {/* FAQs */}
        <div className="container mt-5 pt-lg-5">
          <div className="d-flex faq-landing">
            <div className="faq-landing-1">
              <h2 className="poppins-medium mb-2 mb-lg-4">
                Preguntas frecuentes
              </h2>
              <p className="mb-lg-5">
                ¿Tienes preguntas? Ya tenemos respuestas. Es como si pudiéramos
                oírte pensar.
              </p>
              <div className="d-lg-block d-none">
                <h4 className="poppins-medium mb-2">Did we miss something?</h4>
                <p className="mb-lg-5">
                  Realice una llamada individual con nuestros expertos.
                </p>
                <div className="req-call my-5 my-lg-0">
                  <a
                    href="tel:+918956703515"
                    className="btn btn-dark px-5 d-flex justify-content-between rounded-0"
                    style={{ width: "fit-content" }}
                  >
                    Solicitar una llamada
                  </a>
                </div>
              </div>
            </div>
            <div className="accordion faq-landing-2" id="accordionExample">
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingOne">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    ¿Qué diferencia a DYNEM de otros fabricantes de bicicletas
                    eléctricas?
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  class="accordion-collapse collapse show"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body poppins-thin">
                    <p>
                      DYNEM se destaca por su innovación de vanguardia,
                      prácticas ecológicas y amplias opciones de
                      personalización. Nuestra gigafábrica de última generación,
                      cumplimiento global y equipo de expertos garantizan una
                      calidad de primer nivel y un soporte perfecto desde la
                      producción hasta el servicio posventa, lo que le deja nada
                      más que tranquilidad.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingTwo">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    ¿Puedo personalizar mi bicicleta eléctrica con DYNEM?
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <p>
                      ¡Absolutamente! DYNEM ofrece amplias opciones de
                      personalización, lo que le permite adaptar su bicicleta
                      eléctrica a su estilo y necesidades específicas. Nuestro
                      servicio OEM le permite personalizar la marca, las
                      especificaciones y las características para que coincidan
                      con sus preferencias.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingThree">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    ¿Cuántas bicicletas eléctricas produce DYNEM al año?
                  </button>
                </h2>
                <div
                  id="collapseThree"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingThree"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <p>
                      DYNEM tiene capacidad para producir y personalizar 500.000
                      bicicletas eléctricas al año. Nuestros procesos de
                      producción eficientes y nuestra infraestructura de clase
                      mundial nos permiten satisfacer la creciente demanda
                      global.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingFour">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                  >
                    ¿Cuáles son los beneficios de las soluciones antidumping de
                    DYNEM?
                  </button>
                </h2>
                <div
                  id="collapseFour"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingFour"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <p>
                      Las soluciones legales antidumping de DYNEM permiten a los
                      importadores ahorrar hasta un 87% en impuestos. Nuestros
                      productos cumplen con las regulaciones globales, lo que
                      garantiza igualdad de condiciones sin impuestos
                      antidumping. Esto convierte a DYNEM en una opción rentable
                      y que cumple con las normas para los importadores de todo
                      el mundo.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingfive">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFive"
                    aria-expanded="false"
                    aria-controls="collapseFive"
                  >
                    ¿Cómo apoya DYNEM la sostenibilidad?
                  </button>
                </h2>
                <div
                  id="collapseFive"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingFive"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <p>
                      <Link
                        to={"/"}
                        style={{ color: "inherit", cursor: "auto" }}
                        className="text-decoration-none"
                      >
                        DYNEM
                      </Link>{" "}
                      está comprometido con la sostenibilidad a través de
                      prácticas ecológicas y tecnología innovadora. Nuestras
                      bicicletas eléctricas están diseñadas para reducir la
                      huella de carbono y promover un futuro más ecológico,
                      alineándose con nuestra visión de movilidad sostenible.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingSix">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseSix"
                    aria-expanded="false"
                    aria-controls="collapseSix"
                  >
                    ¿Qué tipo de soporte postventa ofrece DYNEM?
                  </button>
                </h2>
                <div
                  id="collapseSix"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingSix"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <p>
                      DYNEM prioriza la satisfacción del cliente con un soporte
                      posventa dedicado. Desde la compra inicial hasta el
                      mantenimiento a largo plazo, nuestro equipo se compromete
                      a brindar asistencia confiable y fluida, garantizando una
                      experiencia fluida y satisfactoria para nuestros clientes.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-lg-none text-center mt-3">
              <h4 className="poppins-medium mb-2">¿Nos perdimos algo?</h4>
              <p className="mb-lg-5">
                Realice una llamada individual con nuestros expertos.
              </p>
              <div className="req-call my-4">
                <a
                  href="tel:+918956703515"
                  className="btn btn-dark px-5 d-flex justify-content-between rounded-0"
                  style={{ width: "fit-content" }}
                >
                  Solicitar una llamada
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="d-lg-block d-none">
          <div className="d-flex justify-content-center align-items-center mt-4 mt-lg-5">
            <Modal className="primary-button fw-bold px-4 py-2 rounded-5" />
          </div>
        </div>
        <div className="d-lg-none">
          <div className="d-flex justify-content-center align-items-center mt-4 mt-lg-5">
            <ModalMobile className="primary-button fw-bold px-4 py-2 rounded-5" />
          </div>
        </div>
        {/* contact us */}
        <div className="mt-5 py-lg-5" style={{ backgroundColor: "black" }}>
          <div className="container py-lg-5 py-4">
            <div className="d-flex mb-3 mb-lg-0" style={{ gap: "4em" }}>
              <div className="d-none d-lg-block w-50">
                <div className="row">
                  <div className="col-6 p-0">
                    <div className="d-flex justify-content-end">
                      <img
                        src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/News+3.png"
                        className="w-75 p-3"
                      ></img>
                    </div>
                    <div className="d-flex justify-content-end">
                      <img
                        src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/News+2.png"
                        className="w-100 p-3"
                      ></img>
                    </div>
                  </div>
                  <div className="col-6 p-0">
                    <div className="d-flex justify-content-start mt-5">
                      <img
                        src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/grid2.png"
                        className="w-100 p-3"
                      ></img>
                    </div>
                    <div className="d-flex justify-content-start">
                      <img
                        src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/grid4.png"
                        className="w-75 p-3"
                      ></img>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-none d-lg-block">
                <h2 className="poppins-bold mb-4 text-light">Conectemos</h2>
                <form className="contact-us-landing" onSubmit={submit}>
                  <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                    <div className="w-100">
                      <label
                        for="exampleInputEmail1"
                        className="form-label text-light"
                      >
                        Nombre*
                      </label>
                      <input
                        type="text"
                        value={name}
                        onChange={(e) => {
                          setName(e.target.value);
                        }}
                        required
                        class="form-control rounded-0"
                        aria-describedby="emailHelp"
                      />
                    </div>
                  </div>
                  <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                    <div class="w-50">
                      <label
                        for="exampleInputPassword1"
                        class="form-label text-light"
                      >
                        Teléfono*
                      </label>
                      <IntlTelInput
                        onChangeNumber={setPhoneNumber}
                        initOptions={{
                          initialCountry: "auto",
                          geoIpLookup: function (success, failure) {
                            fetch("https://ipapi.co/json")
                              .then((res) => res.json())
                              .then((data) => success(data.country_code))
                              .catch(() => failure());
                          },
                          strictMode: true,
                          separateDialCode: true,
                        }}
                      />
                    </div>
                    <div className="w-50">
                      <label
                        for="exampleInputEmail1"
                        className="form-label text-light"
                      >
                        Correo electrónico*
                      </label>
                      <input
                        type="email"
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                        }}
                        required
                        class="form-control rounded-0"
                        aria-describedby="emailHelp"
                      />
                    </div>
                  </div>

                  <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                    <div className="w-50">
                      <label
                        for="exampleInputEmail1 text-light"
                        className="form-label text-light"
                      >
                        Compañía*
                      </label>
                      <input
                        type="text"
                        value={companyName}
                        required
                        onChange={(e) => {
                          setCompanyName(e.target.value);
                        }}
                        class="form-control"
                        aria-describedby="emailHelp"
                      />
                    </div>
                    <div className="w-50">
                      <label
                        for="exampleInputEmail1"
                        className="form-label text-light"
                      >
                        Product Portfolio*
                      </label>
                      <select
                        onChange={(e) => setProductPortfolio(e.target.value)}
                        class="form-select"
                        required
                        defaultValue=""
                        aria-label="Default select example"
                      >
                        <option value="" selected disabled></option>
                        <option value="E-Bikes">E-Bikes</option>
                        <option value="E-Scooters">E-Scooters</option>
                        <option value="Hyper-Bikes">Hyper-Bikes</option>
                        <option value="Moped">Moped</option>
                      </select>
                    </div>
                  </div>

                  <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                    <div className="w-50">
                      <label
                        for="exampleInputEmail1"
                        className="form-label text-light"
                      >
                        Operational Countries*
                      </label>
                      <input
                        type="text"
                        value={country}
                        onChange={(e) => {
                          setCountry(e.target.value);
                        }}
                        class="form-control"
                        aria-describedby="emailHelp"
                      />
                    </div>
                    <div className="w-50">
                      <label
                        for="exampleInputEmail1"
                        className="form-label text-light"
                      >
                        Annual E-Bike Sales (units)
                      </label>
                      <select
                        onChange={(e) => setSales(e.target.value)}
                        class="form-select"
                        required
                        defaultValue=""
                        aria-label="Default select example"
                      >
                        <option value="" selected disabled></option>
                        <option value="less than 1000 units">
                          less than 1000 units
                        </option>
                        <option value="1000-5000 units">1000-5000 units</option>
                        <option value="5000-50,000 units">
                          5000-50,000 units
                        </option>
                        <option value="50,000+ units">50,000+ units</option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-3">
                    <label
                      for="exampleInputEmail1"
                      className="form-label text-light"
                    >
                      Mensaje*
                    </label>
                    <textarea
                      class="form-control rounded-0"
                      required
                      id="exampleFormControlTextarea1"
                      rows="3"
                      value={enquiry}
                      onChange={(e) => {
                        setEnquiry(e.target.value);
                      }}
                    ></textarea>
                  </div>
                  <div className="mb-3 d-flex justify-content-center">
                    <ReCAPTCHA
                      sitekey="6LftKugqAAAAAP-72NIok7YyszCs5TTba5QBtgBS"
                      onChange={(val) => setCapVal(val)}
                    ></ReCAPTCHA>
                  </div>
                  <button
                    disabled={!capVal}
                    type="submit"
                    class="btn btn-light w-100 poppins-medium rounded-0"
                  >
                    Submit
                  </button>
                </form>
              </div>
            </div>
            <div className="d-lg-none mb-5">
              <h2 className="poppins-bold mb-4 text-light">Conectemos</h2>
              <form className="contact-us-landing" onSubmit={submit}>
                <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                  <div className="w-100">
                    <label
                      for="exampleInputEmail1"
                      className="form-label text-light"
                    >
                      Nombre*
                    </label>
                    <input
                      type="text"
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                      }}
                      required
                      class="form-control rounded-0"
                      aria-describedby="emailHelp"
                    />
                  </div>
                </div>
                <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                  <div class="w-50">
                    <label
                      for="exampleInputPassword1"
                      class="form-label text-light"
                    >
                      Teléfono*
                    </label>
                    <IntlTelInput
                      onChangeNumber={setPhoneNumber}
                      initOptions={{
                        initialCountry: "auto",
                        geoIpLookup: function (success, failure) {
                          fetch("https://ipapi.co/json")
                            .then((res) => res.json())
                            .then((data) => success(data.country_code))
                            .catch(() => failure());
                        },
                        strictMode: true,
                        separateDialCode: true,
                      }}
                    />
                  </div>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label text-light"
                    >
                      Correo electrónico*
                    </label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                      required
                      class="form-control rounded-0"
                      aria-describedby="emailHelp"
                    />
                  </div>
                </div>

                <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label text-light"
                    >
                      Compañía*
                    </label>
                    <input
                      type="text"
                      value={companyName}
                      required
                      onChange={(e) => {
                        setCompanyName(e.target.value);
                      }}
                      class="form-control"
                      aria-describedby="emailHelp"
                    />
                  </div>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label text-light"
                    >
                      Product Portfolio*
                    </label>
                    <select
                      onChange={(e) => setProductPortfolio(e.target.value)}
                      class="form-select"
                      required
                      defaultValue=""
                      aria-label="Default select example"
                    >
                      <option value="" selected disabled></option>
                      <option value="E-Bikes">E-Bikes</option>
                      <option value="E-Scooters">E-Scooters</option>
                      <option value="Hyper-Bikes">Hyper-Bikes</option>
                      <option value="Moped">Moped</option>
                    </select>
                  </div>
                </div>

                <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label text-light"
                    >
                      Operational Countries*
                    </label>
                    <input
                      type="text"
                      value={country}
                      onChange={(e) => {
                        setCountry(e.target.value);
                      }}
                      class="form-control"
                      aria-describedby="emailHelp"
                    />
                  </div>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label text-light"
                    >
                      Annual E-Bike Sales (units)
                    </label>
                    <select
                      onChange={(e) => setSales(e.target.value)}
                      class="form-select"
                      required
                      defaultValue=""
                      aria-label="Default select example"
                    >
                      <option value="" selected disabled></option>
                      <option value="less than 1000 units">
                        less than 1000 units
                      </option>
                      <option value="1000-5000 units">1000-5000 units</option>
                      <option value="5000-50,000 units">
                        5000-50,000 units
                      </option>
                      <option value="50,000+ units">50,000+ units</option>
                    </select>
                  </div>
                </div>
                <div className="mb-3">
                  <label
                    for="exampleInputEmail1"
                    className="form-label text-light"
                  >
                    Mensaje*
                  </label>
                  <textarea
                    class="form-control rounded-0"
                    id="exampleFormControlTextarea1"
                    required
                    rows="3"
                    value={enquiry}
                    onChange={(e) => {
                      setEnquiry(e.target.value);
                    }}
                  ></textarea>
                </div>
                <div className="mb-3 d-flex justify-content-center">
                  <ReCAPTCHA
                    sitekey="6LftKugqAAAAAP-72NIok7YyszCs5TTba5QBtgBS"
                    onChange={(val) => setCapVal(val)}
                  ></ReCAPTCHA>
                </div>
                <button
                  disabled={!capVal}
                  type="submit"
                  class="btn btn-light w-100 poppins-medium rounded-0"
                >
                  Submit
                </button>
              </form>
            </div>
            <div className="row p-2 d-lg-none">
              <div className="col-6 p-0">
                <div className="d-flex justify-content-end">
                  <img
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/News+3.png"
                    className="w-75 p-2"
                  ></img>
                </div>
                <div className="d-flex justify-content-end">
                  <img
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/News+2.png"
                    className="w-100 p-2"
                  ></img>
                </div>
              </div>
              <div className="col-6 p-0">
                <div className="d-flex justify-content-start mt-5">
                  <img
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/grid2.png"
                    className="w-100 p-2"
                  ></img>
                </div>
                <div className="d-flex justify-content-start">
                  <img
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/grid4.png"
                    className="w-75 p-2"
                  ></img>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LandingPage2Es;
